export default __webpack_public_path__ + "static/media/32.ef734762.png";